import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';
import Reflux from 'reflux';
import {Form, InputWrapper, Input, Button} from 'ui-library';
import i18n from 'i18n';
import styles from './Registration/containers/RoleForm/RoleForm.less';


import {changePage, languageChange} from 'redux/modules/app';
import {acceptRegistrationInvite} from 'redux/modules/shared';

import AppActions from 'modules/legacy/js/actions/app';
import AuthActions from 'modules/legacy/js/actions/auth';
import emailRegex from 'modules/legacy/js/mixins/emailRegex';
import passwordRegex from 'modules/legacy/js/mixins/passwordRegex';
import recaptcha from 'modules/legacy/js/mixins/recaptcha';

import API from 'modules/legacy/js/lib/api';
import {LoginSupportLinks as SupportLinks} from 'modules/shared/containers';
import Loading from 'modules/legacy/js/components/loading';
import {PartnerFormRoute} from 'apps/advertisers/PartnerForm';

import {advertisersCoverImg, logoImgObs} from 'assets/images';

function mapStateToProps({app, shared}) {
  const {session, user} = shared;
  const {currentLanguage, partnerSettings} = app;
  return {session, user, currentLanguage, partnerSettings};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({acceptRegistrationInvite, changePage, languageChange}, dispatch);
}

function isAlreadyRegisteredError({code}) {
  return code === 'CONFLICT';
}

const RegistrationInvite = createClass({
  displayName: 'registerView',

  propTypes: {
    user: PropTypes.object,
    session: PropTypes.object,
    params: PropTypes.object,
    acceptRegistrationInvite: PropTypes.func,
    changePage: PropTypes.func,
    currentLanguage: PropTypes.string.isRequired
  },

  mixins: [
    emailRegex,
    passwordRegex,
    recaptcha,
    Reflux.listenTo(AuthActions.registerError, 'onRegisterError'),
    Reflux.listenTo(AppActions.reCAPTCHALoaded, 'updateReCaptchaWidget')
  ],

  getInitialState() {
    const {token} = this.props.params;
    return {
      token,
      password: '',
      name: '',
      lastName: '',
      showPassword: false,
      loading: true,
      registrationInvite: null,
      email: '',
      errorMessage: '',
      isTermsChecked: false
    };
  },

  componentDidMount() {
    const {token, partnerSettings} = this.props.params;

    if (partnerSettings) return;

    API.getRegistrationInviteByToken({token}, (err, response) => {
      this.setState({loading: false});

      if (response.id) {
        this.setState({
          registrationInvite: response.data,
          email: response.data.email
        });
      }
    });
  },

  componentWillReceiveProps({session, user}) {
    if (session.error) return this.onRegisterError(session.error);

    if (user) {
      return AuthActions.registerSuccess({
        user,
        token: session.token,
        account: user.account
      });
    }

    return null;
  },

  onRegisterError(error) {
    if (isAlreadyRegisteredError(error)) this.handleAlreadyRegisteredError();
    else this.handleGenericError();

    this.updateReCaptchaWidget();
  },

  onSendRegistrationData(event) {
    if (event) event.preventDefault();

    if (!this.validateForm()) {
      if (event) return event.stopPropagation();
    }

    const {email, name, lastName, password, token} = this.state;
    const params = {email, password, name, lastName, role: 'advertiser', token};

    return this.props.acceptRegistrationInvite(params);
  },

  getForm() {
    const {showPassword, email, errorMessage, isTermsChecked} = this.state;

    return (
      <div className='form'>
        <div className='title vf-text-gray-dark'>
          {i18n.get('REGISTER_REGISTER')}
        </div>

        <h4 className='vf-text-gray-dark'>
          {i18n.getHTML('REGISTER_REGISTER_DESCRIPTION', {email})}
        </h4>

        <Form onSubmit={this.onSendRegistrationData} className='margin-top-1x'>
          <div className='vf-input-group'>
            <InputWrapper ref='nameWrapper' className='lg vf-row no-margin'>
              <i className='vf-icon icon-user'></i>
              <Input
                ref='nameInput'
                value={this.state.name}
                onChange={(event) => this.handleStateInputChange(event, 'name')}
                className='register-input col-xs-6'
                placeholder={i18n.get('REGISTER_FIRST_NAME_PLACEHOLDER')}
                type='text'
                inputSize='lg'
              />
              <Input
                ref='lastNameInput'
                value={this.state.lastName}
                onChange={(event) => this.handleStateInputChange(event, 'lastName')}
                className='register-input col-xs-5 col-xs-offset-1'
                placeholder={i18n.get('REGISTER_LAST_NAME_PLACEHOLDER')}
                type='text'
                inputSize='lg'
              />
            </InputWrapper>

            <InputWrapper
              ref='passwordWrapper'
              className='lg password-wrapper margin-top-2x'
            >
              <i className='vf-icon icon-locked'></i>
              <Input
                placeholder={i18n.get('REGISTER_PASSWORD_PLACEHOLDER')}
                ref='passwordInput'
                value={this.state.password}
                onChange={(event) => this.handleStateInputChange(event, 'password')}
                className='register-input'
                type={showPassword ? 'text' : 'password'}
                autoComplete='off'
                inputSize='lg'
              />
              <i
                className={
                  `vf-icon ${
                    showPassword ? 'icon-eye-disabled' : 'icon-eye-1'
                  } show-password`
                }
                onClick={() => this.setState({showPassword: !showPassword})}
              ></i>
            </InputWrapper>

            <InputWrapper hidden />
          </div>

          <div className='margin-top-2x'>
            <span className='vf-text-danger'>
              {errorMessage}
            </span>
          </div>

          <div id='recaptcha' className='recaptcha-container' ref='recaptcha'></div>

          <div className='flex flex-start'>
            <input
              type='checkbox'
              value={1}
              className='margin-right-Hx'
              checked={isTermsChecked}
              style={{marginTop: 4}}
              onClick={() => this.setState({isTermsChecked: !this.state.isTermsChecked})}
            />
            <div
              className='vf-text-secondary vf-font-bold margin-right-1x vf-clickable'
              onClick={() => this.setState({isTermsChecked: !this.state.isTermsChecked})}
            >
              {i18n.getHTML('REGISTER_ACCEPT_TOS')}
            </div>
            <Button
              color='primary'
              type='submit'
              className={classnames(styles['reg-button'], {[styles.disabled]: !isTermsChecked})}
              style={{marginLeft: 'auto'}}
              disabled={!isTermsChecked}
            >
              {i18n.get('REGISTER_REGISTER_ME')}
            </Button>
          </div>
        </Form>
      </div>
    );
  },

  getInvalidTokenView() {
    return (
      <div>
        <div className='title vf-text-gray-dark'>
          {i18n.get('REGISTER_EXPIRED_LINK')}
        </div>

        <h4 className='vf-text-gray-dark'>
          {i18n.get('REGISTER_EXPIRED_LINK_DESCRIPTION')}
        </h4>
      </div>
    );
  },

  validateForm() {
    let valid = true;
    let errorFocused = false;
    const addErrorFn = (el) => {
      valid = false;
      el.parentNode.classList.add('error');

      if (errorFocused === false) {
        el.focus();
        errorFocused = true;
      }
    };

    if (!this.state.name) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.nameInput));
      this.setState({errorMessage: i18n.get('REGISTER_FIRST_NAME_IS_REQUIRED')});
      return valid;
    }

    if (!this.passwordRegex.test(this.state.password)) {
      addErrorFn(ReactDOM.findDOMNode(this.refs.passwordInput));
      this.setState({errorMessage: i18n.get('REGISTER_INVALID_PASSWORD_LENGTH')});
    }

    return valid;
  },

  handleStateInputChange(event, key) {
    event.target.parentNode.classList.remove('error');
    this.setState({
      [key]: event.target.value,
      errorMessage: ''
    });
  },

  handleAlreadyRegisteredError() {
    AppActions.displayAlert({
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      type: 'error',
      message: i18n.get('REGISTER_EMAIL_ALREADY_REGISTERED')
    });
  },

  handleGenericError({message}) {
    AppActions.displayAlert({
      message,
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      type: 'error'
    });
  },

  render() {
    const {partnerSettings} = this.props;
    const {loading, registrationInvite} = this.state;

    if (partnerSettings) return <PartnerFormRoute />;
    if (loading) return <Loading active />;

    const coverStyle = {backgroundImage: `url('${advertisersCoverImg}')`};

    return (
      <div className='vf-row no-space'>
        <div className='col-md-5 col-xs-12'>
          <div className='flex no-space start-md center-xs'>
            <div className='register'>
              <div className='background' />
              <div className='overlay' />

              <div className='form'>
                <div className='flex between-xs margin-vertical-1x'>
                  <img alt='' src={logoImgObs} className='logo' />

                  <Link
                    to='/login'
                    className='vf-btn outline vf-btn-primary vf-btn--sm'
                    style={{padding: '1.2rem 4rem'}}
                  >
                    {i18n.get('REGISTER_LOG_IN')}
                  </Link>
                </div>
              </div>

              {registrationInvite ? this.getForm() : this.getInvalidTokenView()}

              <SupportLinks />
            </div>
          </div>
        </div>
        <div className='col-md-7 advertiser-cover' style={coverStyle}>
          <div className='curtain'></div>
        </div>
      </div>
    );
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationInvite);
